import { useQuery } from '@hooks/reactQuery';

import { getRUConfigurationConfigs } from '@api/ruConfigurations';

import { optionsFormatted } from '@utils/formatter';

import { TNameTitle } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { RU_CONFIGURATIONS_CONFIGS } from '@constants/queryKeys';

interface IUseQueryRUConfigurationConfigsReturned {
	ruConfigurationConfigs: TSelectOption<string>[];
	isLoadingRUConfigurationConfigs: boolean;
}

export const useQueryRUConfigurationConfigs = (): IUseQueryRUConfigurationConfigsReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery<TNameTitle[], TSelectOption<string>[]>({
		queryKey: [RU_CONFIGURATIONS_CONFIGS],
		queryFn: getRUConfigurationConfigs,
		select: (data) => {
			return optionsFormatted(data);
		},
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		ruConfigurationConfigs: data || [],
		isLoadingRUConfigurationConfigs: isInitialLoading,
	};
};
